import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-home',
  imports: [CommonModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent {

  token$: any;

  constructor(private authService: AuthService) {
    this.token$ = this.authService.getAccessToken()

    console.log(this.authService.getActiveAccount())
    console.log(this.authService.getAllAccounts())
  }

}
